import * as React from 'react';

import './Organisation.scss';
import { Card, Button, Modal, InputGroup, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TreeOverview from '../../Shared/TreeOverview/TreeOverview';

function Organisation(props) {
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const t = useTranslate();
    const myRef = React.useRef<any>();

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const [newOrgName, setNewOrgName] = useState("");
    const [orgName, setOrgName] = useState("");

    const [orgs, setOrgs] = useState([{}]);
    const [selectedOrg, setSelectedOrg] = useState(null);
    
    const [show, setShow] = useState(false);
    const [nameChangeShow, setNameChangeShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = (orgId) => {
        setSelectedOrg(orgId);
        setShow(true);
    };

    const handleKeyDownCreate = event => {
        if (event.key === 'Enter') {
            handleCreateOrg();
        }
    }

    const handleKeyDownEdit = event => {
        if (event.key === 'Enter') {
            handleNameChangeOrg();
        }
    }

    const handleNameChangeClose = () => setNameChangeShow(false);
    const handleNameChangeShow = (orgId, orgName) => {
        setSelectedOrg(orgId);
        setOrgName(orgName);
        setNewOrgName(orgName);
        setNameChangeShow(true);
    };

    const handleNewOrgNameChange = (evt) => {
        setNewOrgName(evt.target.value);
    };

    const handleOrgNameChange = (evt) => {
        setNewOrgName(evt.target.value);
        setOrgName(evt.target.value);
    };

    const handleCreateOrg = () => {
        axios.post('/api/orgelements', {
            name: newOrgName,
            parent: selectedOrg != null ? selectedOrg : ""
        }, {
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            fetchData();
            notifySuccess(t("organisation.toast_organisation_created"));
            setShow(false);
        });
    };

    const handleNameChangeOrg = () => {
        axios.post('/api/orgelements/name/' + selectedOrg, {
            newName: orgName,
        }, {
            headers: {'x-access-token': auth.user["token"]}
        })
        .then(function (response) {
            fetchData();
            setNameChangeShow(false);
        });
    };
    
    async function fetchData() {
        axios.single({
            method: "get",
            url: "/api/orgelements",
            responseType: "json",
            headers: {'x-access-token': auth.user["token"]}
        })
        .then((res) => {
            setOrgs(res.data);
        });
    }

    useEffect(() => {
        if (auth.user["userdata"] == undefined) { window.location.href = "/login"; }
        fetchData();
    }, []);

    return (
        <div className="maincontent">
            <div className="organisation-container">
                <div className="pagetitle-container">
                    <h1>{t("organisation.page_name")}</h1>
                </div>
                <Card>
                    <Card.Body>
                        <h4 className="header-title">{t("organisation.page_name")}</h4>
                        { orgs != undefined && orgs.length > 0 ?
                            <TreeOverview
                                data={orgs}
                                onEditClick={(org) => handleNameChangeShow(org["_id"], org["name"])}
                                onAddElementClick={(org) => handleShow(org["_id"])}
                                addElementText={org => t("organisation.add_new_under") + ` ${org["name"]}`}
                                elementName={org => `${org["name"]}`}
                                hideEditButton={false}
                                hideNewButton={false}
                                accentColor="#fcb85f"
                                backgroundColor="#fff1de"
                            ></TreeOverview>
                        : ""}
                    </Card.Body>
                </Card>
                <Modal show={show} onHide={handleClose} onEntered={() => myRef.current.focus()}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("organisation.organisation_add")}{selectedOrg == undefined ? "" : " under " + orgs.filter(item => item["_id"] == selectedOrg)[0]["name"]}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("organisation.organisation_name")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control ref={myRef} onKeyDown={handleKeyDownCreate} onChange={handleNewOrgNameChange} />
                        </InputGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleClose}>
                            {t("organisation.closed_without_save")}
                        </Button>
                        <Button onClick={handleCreateOrg}>
                            {t("organisation.save")}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={nameChangeShow} onHide={handleNameChangeClose} onEntered={() => {
                    myRef.current.focus();
                }}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("organisation.name_changed")} {selectedOrg == undefined ? "" : orgs.filter(item => item["_id"] == selectedOrg)[0]["name"]}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("organisation.organisation_name")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control ref={myRef} onKeyDown={handleKeyDownEdit} onChange={handleOrgNameChange} value={newOrgName} />
                        </InputGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleNameChangeClose}>
                            {t("organisation.closed_without_save")}
                        </Button>
                        <Button onClick={handleNameChangeOrg}>
                            {t("organisation.save")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
}
 
export default Organisation;